export class TaskManager {
    private _tasks: Array<Promise<unknown>> = [];

    get tasks(): ReadonlyArray<Promise<unknown>> {
        return this._tasks;
    }

    public register(promise: Promise<unknown>) {
        this._tasks.push(promise);

        const unregister = () => {
            const index = this._tasks.indexOf(promise);
            if (index !== -1) {
                this._tasks.splice(index, 1);
            }
        };

        promise.then(unregister).catch(unregister);
    }
}
